var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValmet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 518.77 131.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:url(#linear-gradient);}.cls-4{clip-path:url(#clip-path-2);}.cls-5{fill:url(#linear-gradient-2);}.cls-6{fill:#fff;}.cls-7{clip-path:url(#clip-path-3);}.cls-8{fill:url(#linear-gradient-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.44,67.52l-49,49,10.82,10.82c10.35,10.34,20.69,0,20.69,0l59.82-59.82Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 131.15,
    y1: 539.41,
    x2: 132.15,
    y2: 539.41,
    gradientTransform: "translate(16650.17 -3852.81) rotate(90) scale(29.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41903f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#41903f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#4ba749"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#4faf4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4faf4d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M438.27,4.6,427.44,15.45l49,49h42.33L459,4.6S454.36,0,448.23,0c-3.06,0-6.51,1.15-10,4.6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 135.91,
    y1: 544.1,
    x2: 136.91,
    y2: 544.1,
    gradientTransform: "matrix(29.99, 0, 0, -29.99, -3622.78, 16349.76)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41903f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#459a43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#4ca94a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#4faf4d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4faf4d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M378.44,67.52l48.07,48.07,21.17-21.14-26.9-26.9Zm0-3.1h42.33L447.69,37.5,426.54,16.33Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 137.12,
    y1: 540.9,
    x2: 138.12,
    y2: 540.9,
    gradientTransform: "translate(10083.45 38037.13) rotate(180) scale(70.2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c7c7b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#646363"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 416.02,
    y: 45.5,
    width: 114.2,
    height: 114.2,
    transform: "translate(66.03 364.6) rotate(-45)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 418.05,
    y: -22.85,
    width: 110.13,
    height: 110.13,
    transform: "translate(115.79 343.98) rotate(-45)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M299.7,64.62H277.75c1.11-8,3.58-10.6,11.47-10.6,7.39,0,10.23,1.85,10.48,10.6m-11.84-24.9c-18.12,0-29.71,7.52-29.71,32.92,0,25.89,13.19,33.66,30.94,33.66a80.88,80.88,0,0,0,22.81-3.46l-2.83-14.39a86.73,86.73,0,0,1-17.51,2.09c-9.13,0-13.69-1.85-13.93-12h38.59c1.72-32.42-7.4-38.83-28.36-38.83"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M43.79,78C40.17,64.17,30.5,34.33,25,19.23c-.49-1.35-2.19-3.68-4.34-3.68H0v.9S4,17,6.93,25.79c5.89,17.9,19.91,62,24.66,78.77H54.87c8.26-20.1,23.33-68.92,29.25-89H63.21C59,30.08,48.85,63.56,43.79,78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M153.44,15.55h-19V86.69c0,22.39,21.9,19.06,21.9,19.06-2.55-5.13-2.91-13.51-2.91-19.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M179.61,57.72a30.35,30.35,0,0,1,8.26-1.11c8.63,0,10.48,3.08,10.48,14.55v33.41h18.86V69.68a55,55,0,0,0-1.23-12,46.34,46.34,0,0,1,9.46-1.07c8.63,0,10.48,3.08,10.48,14.55v33.41h18.87V69.68c0-22.69-7.77-30-25.28-30a69.18,69.18,0,0,0-21.82,4.06c-3.82-2.83-9.12-4.06-15.78-4.06a97.27,97.27,0,0,0-31.32,5.67v59.18h19Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M367.08,57.72V41.45H347.35V30.82a77.44,77.44,0,0,1,1.28-15.27s-20.27,2.63-20.27,16.52v9.38H318.13V57.72h10.23V83.24c0,18.86,7.77,23.06,21.7,23.06,6.78,0,14.3-1.24,19-3.21L366,88.54a30.82,30.82,0,0,1-10.11,1.73c-6.66,0-8.51-2.59-8.51-9V57.72Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.69,90.51a31.65,31.65,0,0,1-10.48,1.73c-7.4,0-9-1.11-9-7.52s2.46-7,9.25-7a42.84,42.84,0,0,1,10.23.86Zm18,10.85V64.25c0-18.74-8.88-24.53-27.74-24.53-9.37,0-11.85.34-19.13,2.19L76.44,58a72.75,72.75,0,0,1,20-2.87c12.33,0,14.3,2.46,14.3,11.22a70.89,70.89,0,0,0-14.3-1.61c-15,0-24.66,2.84-24.66,20.6,0,16.52,6.16,21,27,21,9.25,0,21.45-1.86,30-4.94"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 353.5,
    y: 6.39,
    width: 119.15,
    height: 119.15,
    transform: "translate(74.34 311.41) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValmet);
export default __webpack_public_path__ + "static/media/valmet.d300ad818616f992e83d168d25cc5144.svg";
export { ForwardRef as ReactComponent };